/**
 * @file A place to put string constants. Extract into a constants folder organized by domain
 * should this ever become unwieldy.
 */

const onei3 = 'onei3';

export const ONEI3_SERVICE_ACCESS_MGMT = `${onei3}:service:access_management`;

export const ONEI3_ASSET_TYPE_ATTR_KEY = 'onei3:asset.type';
